import { useMemo } from 'react';
import { useTheme } from './use-theme';
import type { Organisation } from '../types/objects';

export function useBrandIcon(
  organisation: Pick<Organisation, 'brand_icon' | 'dark_brand_icon' | 'name'> | null | undefined,
): string | null {
  const { resolvedTheme } = useTheme();

  return useMemo(() => {
    if (!organisation) return null;
    if (resolvedTheme === 'dark' && organisation.dark_brand_icon) {
      return organisation.dark_brand_icon;
    }
    return organisation.brand_icon ?? null;
  }, [organisation, resolvedTheme]);
}
